<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">AUD-11</div>
            <div class="card-subtitle mt-2">
              Pagamentos a fornecedores que excederam o teto do porte de empresa dos mesmos (MENSAL)
            </div>
          </div>
          <div class="card-body chart-body">
            <bar-chart ref="my_chart" v-if="canRenderGraph" :chartdata="chart1.chartdata" :options="chart2.options"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">AUD-11</div>
            <div class="card-subtitle mt-2">
              Pagamentos a fornecedores que excederam o teto do porte de empresa dos mesmos (ANUAL)
            </div>
          </div>
          <div class="card-body chart-body">
            <bar-chart ref="my_chart" v-if="canRenderGraph" :chartdata="chart2.chartdata" :options="chart2.options"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../../Charts/BarChart'
export default {
  data() {
    return {
      canRenderGraph: false,
      chart1: {
        chartdata: {
          labels: [],
          datasets: [
            {
              label: "Valor total das notas fiscais",
              backgroundColor: '#6908b9',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#6908b9',
              data: [],
            },
          ],
        },  
        options: {
          legend: {
            onClick: null
          },
          tooltips: {
            mode: 'index',
            callbacks: {
              label(vars){
                let float = parseFloat(vars.value).toFixed(2)
                let parts = float.toString().split(".")
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                let formatted = parts.join(".").replace('.', ',')

                return 'Valor total das notas fiscais: ' + formatted
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      },
      chart2: {
        chartdata: {
          labels: [],
          datasets: [
            {
              label: "Valor total das notas fiscais",
              backgroundColor: '#6908b9',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#6908b9',
              data: [],
            },
          ],
        },  
        options: {
          legend: {
            onClick: null
          },
          tooltips: {
            mode: 'index',
            callbacks: {
              label(vars){
                let float = parseFloat(vars.value).toFixed(2)
                let parts = float.toString().split(".")
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                let formatted = parts.join(".").replace('.', ',')

                return 'Valor total das notas fiscais: ' + formatted
              }
            }
          },
          scales: {
            xAxes: [{
              stacked: true,
            }],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    };
  },
  methods: {
    getGraph(fd){
      const self = this;
			const api = this.$store.state.api + 'aud11s/graph/'

			self.$http.post(api, fd)
				.then((response) => {
          self.chart1.chartdata.labels = response.data.month.labels
          self.chart1.chartdata.datasets = response.data.month.datasets

					self.chart2.chartdata.labels = response.data.year.labels
          self.chart2.chartdata.datasets = response.data.year.datasets

          self.canRenderGraph = true
				})
				.catch((error) => {
					self.$message('Erro', error.response.data, 'error');
				});
    },
  },
  components: {
    BarChart,
  }
};
</script>

<style>
.strong {
  font-weight: 700;
}
tr:hover {
  background-color: #ead6fa;
}
.details-container {
  height: 720px;
  overflow-y: scroll
}
</style>
